import AssessmentCard from "pages/PanelPage/components/AssessmentCard/AssessmentCard";

export default AssessmentCard;
